import { Button, Form, message, Modal, Space } from "antd";
import TextArea from "antd/lib/input/TextArea";
import { FC, useState } from "react";
import InputNum from "../../../components/form/inputNum";
import DealerAdminStore from "../../../contexts/dealerAdminStore";
import DealerStore from "../../../contexts/dealerStore";
import _t from "../../../lang/translate";
import { sendClips } from "../../../services/dealerService";
import { ClipLogType } from "../../../types/clipTypes";
import { isAxiosError } from "../../../utilities/typeGuard";

const DealerAdminClipUpdate: FC = () => {
  const { dealer } = DealerStore.useContainer();
  const { admin, setAdmin } = DealerAdminStore.useContainer();
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  const openModal = () => setIsVisible(true);
  const closeModal = () => setIsVisible(false);

  const handleSubmit = async (values: ClipLogType) => {
    try {
      setLoading(true);
      await sendClips(dealer.id, values);
      // This is saved here to so that if we want to allow adding "old" clips to dealer, so then there would
      // be a select-box for the "clip type" that we are adding to the dealer
      //const nextClipAmount = admin.clipAmount + values.amount;
      //setAdmin({...admin, clipAmount: nextClipAmount});
      const nextCreditAmount = admin.creditsLeft + values.amount;
      setAdmin({ ...admin, creditsLeft: nextCreditAmount });
      closeModal();
    } catch (error) {
      const errorMessage = isAxiosError(error) ? error.response?.data?.message : null;
      message.error(errorMessage || _t("msg.unknown_error"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button onClick={openModal}>{_t("add", "credits")}</Button>
      <Modal width={500} visible={isVisible} onCancel={closeModal} title={null} footer={null}>
        <Form<ClipLogType>
          onFinish={handleSubmit}
          initialValues={{ amount: 1, description: "Manuel klip" }}
          layout="vertical"
        >
          <h2 className="modal-title">{_t("add", "clips")}</h2>
          <Form.Item
            name="amount"
            label={_t("amount")}
            rules={[{ required: true }]}
            extra={
              <Form.Item noStyle shouldUpdate>
                {({ getFieldValue }) => (
                  <small className="d-block pt-05">
                    {_t("total", "clips")}: {(getFieldValue("amount") || 0) + admin.clipAmount}
                  </small>
                )}
              </Form.Item>
            }
          >
            <InputNum disabled={loading} />
          </Form.Item>

          <Form.Item name="description" label={_t("description")} rules={[{ required: true, whitespace: true }]}>
            <TextArea disabled={loading} autoSize={{ minRows: 1, maxRows: 3 }} />
          </Form.Item>
          <Form.Item shouldUpdate noStyle>
            {({ submit }) => (
              <div className="text-right">
                <Space>
                  <Button type="ghost" onClick={closeModal} disabled={loading}>
                    {_t("cancel")}
                  </Button>
                  <Button onClick={submit} loading={loading} type="primary">
                    {_t("save")}
                  </Button>
                </Space>
              </div>
            )}
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default DealerAdminClipUpdate;
